import { createContext } from "react";

export interface SetupDialogContextValue {
  canSkip?: boolean;
  onSkip?: () => void | Promise<void>;
  canComplete?: boolean;
  onComplete: () => void | Promise<void>;
}

export const SetupDialogContext = createContext<SetupDialogContextValue | null>(null);
